module.exports = __webpack_public_path__ + "img/jing6.bdefdda0.jpg";